// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import _ from 'lodash';
import router from './router';
import routerIntercept from '@/config/routerIntercept';
import * as echarts from "echarts"
import animate from 'animate.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import wx from 'weixin-js-sdk'
import Print from 'vue-print-nb'
import vueLazyload from 'vue-lazyload'
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
//提示窗model
import modal from '../src/utils/model'
//注册为了指令
Vue.use(Print);  
Vue.use(vueLazyload, {
  preLoad: 1.5, // 设置预加载的图片数量为当前视窗加载数量的1.5倍
});
const bus = new Vue()
Vue.prototype.$bus = bus
Vue.prototype.wx = wx
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.use(animate);
Vue.component('ImageUpload', ImageUpload)
Vue.config.productionTip = false;
// 模态框对象
Vue.prototype.$modal = modal
// 挂载lodash工具库
Vue.prototype._ = _;
Vue.use(routerIntercept);
// 设置cookie
Vue.prototype.setCookie = function(c_name,value,days) {
  var cookies = document.cookie.split(';');
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = c_name + "=" + value + ";" + expires + ";path=/";

  // var exdate=new Date()
  // exdate.setDate(exdate.getDate()+expiredays)
  // document.cookie=c_name+ "=" +escape(value)+
  //   ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
};
// 读取cookie
Vue.prototype.getCookie=function(c_name) {
  if (document.cookie.length>0)
  {
    var  c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1)
    {
      c_start=c_start + c_name.length+1
     var c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
    }
  }
  return ""
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js